export default {
    created() {
        EventBus.on(
            'activities-listing-filters:displayDropdown',
            this.updateDropdownVisibilityFromEvent,
        );
    },
    destroyed() {
        EventBus.off(
            'activities-listing-filters:displayDropdown',
            this.updateDropdownVisibilityFromEvent,
        );
    },
    methods: {
        updateDropdownVisibilityFromEvent(filterCode) {
            if (filterCode === this.filter.code) {
                this.updateVisibility(true);
            }
        },
    },
};
